import { useState, useEffect, useCallback } from 'react';
import { useStateContext } from '../../../../../contexts/ContextProvider';

export const useProdusToOfertaStatus = () => {
  const { token } = useStateContext();
  const [productStatusOptions, setProductStatusOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchStatusOptions = useCallback(async () => {
    if (!token) return;
    
    setLoading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/produs-oferta-status?token=${token}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        }
      });

      if (response.ok) {
        const data = await response.json();
        const dataWithColors = data.map(status => ({
          ...status,
          color: status.color || getDefaultStatusColor(status.label || status.id)
        }));
        setProductStatusOptions(dataWithColors);
      } else {
        // message.error('Eroare la încărcarea statusurilor produselor');
      }
    } catch (error) {
      console.error('Eroare la încărcarea statusurilor:', error);
      // message.error('Eroare de conexiune');
    } finally {
      setLoading(false);
    }
  }, [token]);

  const getDefaultStatusColor = (statusLabel) => {
    const colorMap = {
      'disponibil': '#52c41a',
      'indisponibil': '#ff4d4f',
      'comandat': '#1890ff',
      'în stoc': '#52c41a',
      'epuizat': '#ff4d4f',
      'în așteptare': '#faad14'
    };
    
    const lowerLabel = statusLabel?.toString().toLowerCase();
    return colorMap[lowerLabel] || '#8c8c8c';
  };

  useEffect(() => {
    fetchStatusOptions();
  }, [fetchStatusOptions]);

  return {
    productStatusOptions,
    loading,
    fetchStatusOptions
  };
}; 